import type { PageCard } from '@/play/pageTypes'
import { ThirstyCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'thirsty',
  number: 39,
  title: 'Thirsty',
  question: 'Does a want shown only by the world, a drooping flower downhill from a pond, read as a goal without words, and does the flower lifting as the water arrives feel like enough?',
  status: 'open',
  accent: '#cfe3f2',
  CardArt: ThirstyCardArt,
}
